import { useState, useEffect } from 'react';
import { SalesFunnel } from '../types';

export interface UseFunnelsReturn {
  funnels: SalesFunnel[];
  loading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
}

export function useFunnels(fetchFunnels: () => Promise<SalesFunnel[]>): UseFunnelsReturn {
  const [funnels, setFunnels] = useState<SalesFunnel[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const refetch = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchFunnels();
      setFunnels(data);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to fetch funnels'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refetch();
  }, []);

  return { funnels, loading, error, refetch };
}

